<template>
    <layout-with-sidebar>
        <HeaderComponent/>
        <div class=" ed-bg text-color" style="min-height:100vh">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="navbar navbar-expand-lg navbar-light bg-light  row">
                            <div class="col-2 text-left">
                                <button class="btn btn-default "> <
                                </button>
                            </div>
                            <div class="col-6 text-center">
                                <h1 style="color:black">Cropper</h1>
                            </div>
                            <div class="col-4 text-right">

                                <button @click="save" class="btn btn-success my-2 my-sm-0" type="submit">Salva
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-10">
                        <div style="width:500px;height: 400px">
                            <vue-cropper
                                    ref="cropper"
                                    :src="img"
                                    alt="Source Image"

                            >
                            </vue-cropper>
                        </div>

                        <a
                                href="#"
                                role="button"
                                @click.prevent="showFileChooser"
                        >
                            Upload Image
                        </a>

                        <input
                                ref="input"
                                type="file"
                                name="image"
                                accept="image/*"
                                @change="setImage"
                                style="display: none"
                        />

                    </div>

                    <div class="col-2">
<img id="croppedImg" src="" width="100%">
                    </div>
                </div>


            </div>
        </div>
    </layout-with-sidebar>
</template>


<script>
    // @ is an alias to /src

    import axios from 'axios'

    // import LayoutWithSidebar from "./layouts/LayoutWithSidebar";
    import HeaderComponent from "../../components/HeaderComponent";
    import VueCropper from 'vue-cropperjs';
    import 'cropperjs/dist/cropper.css';


    export default {
        name: 'Cropper',
        components: {
            //     LayoutWithSidebar,
            HeaderComponent,
            VueCropper
        },
        data: function () {
            return {
                img: '/images/IMG_9358.JPG'
            }
        }
        ,
        mounted: function () {

        }
        ,
        computed: {}
        ,
        methods: {
            save: function () {
                let data =this.$refs.cropper.getCroppedCanvas().toDataURL();
                document.getElementById("croppedImg").src = data;
            },
            showFileChooser() {
                this.$refs.input.click();
            },
            setImage: function (e) {
                const file = e.target.files[0];
                if (file.type.indexOf('image/') === -1) {
                    alert('Please select an image file');
                    return;
                }
                if (typeof FileReader === 'function') {
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        this.imgSrc = event.target.result;
                        // rebuild cropperjs with the updated source
                        this.$refs.cropper.replace(event.target.result);
                    };
                    reader.readAsDataURL(file);
                } else {
                    alert('Sorry, FileReader API not supported');
                }
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

    input[type="file"] {
        display: none;
    }

    .content {
        display: flex;
        justify-content: space-between;
    }
    .cropper-area {
        width: 614px;
    }
    .actions {
        margin-top: 1rem;
    }
    .actions a {
        display: inline-block;
        padding: 5px 15px;
        background: #0062CC;
        color: white;
        text-decoration: none;
        border-radius: 3px;
        margin-right: 1rem;
        margin-bottom: 1rem;
    }
    textarea {
        width: 100%;
        height: 100px;
    }
    .preview-area {
        width: 307px;
    }
    .preview-area p {
        font-size: 1.25rem;
        margin: 0;
        margin-bottom: 1rem;
    }
    .preview-area p:last-of-type {
        margin-top: 1rem;
    }
    .preview {
        width: 100%;
        height: calc(372px * (9 / 16));
        overflow: hidden;
    }
    .crop-placeholder {
        width: 100%;
        height: 200px;
        background: #ccc;
    }
    .cropped-image img {
        max-width: 100%;
    }
</style>